module.exports = __webpack_public_path__ + "static/img/geometry3.080d8856.jpg";